import chart from 'components/chart/chart'
import initVanillaSelect from 'components/select-vanilla'
import eventsService from 'services/events'

const $currencySelect = document.querySelector<HTMLSelectElement>('#single-rate-select')
const $chartWrapper = document.getElementById('single-chart')

declare let SINGLE_RATE_CURRENCY: string

init()

function init(): void {
  if ($chartWrapper) {
    chart.init(
      {
        element: 'single-chart',
        currency: SINGLE_RATE_CURRENCY,
        bank: 'nbp',
        timeRange: '5-days',
      },
      false,
    )
  }

  initVanillaSelect()
  eventsService.dispatchCustomEvent('single-rate-select', { value: SINGLE_RATE_CURRENCY })
  window.addEventListener('single-rate-select change', onSelectChange)
}

function onSelectChange(): void {
  const $el = document.querySelector<HTMLElement>(`[data-dropdown-item-value="${$currencySelect.value}"]`)
  window.location.href = $el.dataset.dropdownRedirect
}
